package org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.pms_config.apaleo_properties


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import org.hs_soft.runmynesto.domain.model.general_error_model.GeneralError

@Serializable
data class Data(
    @SerialName("cashAssist")
    val cashAssist: CashAssist?,
    @SerialName("errors")
    val errors: List<GeneralError?>?=null,
)